import type { EulerRotation } from '@mindcloudxai_3d/core';

/**
 * 根据源数据 up-axis 计算场景基础旋转。
 *
 *   - `isYup === true`  → 数据已是 Y-up，不额外旋转
 *   - `isYup === false` → 原始 Z-up 数据，需要转换到 Y-up 展示空间 → X 轴 +90°
 *     （entity 已带 loader Rz(180°)，叠加 Rx(+90°) 后顶点 (x,y,z)→(-x,z,y)，
 *      与 transform.ts 的 COLMAP 坐标映射一致）
 *
 * 与数据来源（COLMAP、手动标注等）无关，只看 up-axis 标记。
 * renderer SDK 只消费最终的 `EulerRotation`。
 */
export function sceneBaseRotation(isYup: boolean): EulerRotation {
  return isYup ? { x: 0, y: 0, z: 0 } : { x: Math.PI / 2, y: 0, z: 0 };
}
